export class NotaFiscalModel {
    EmpresaCnpjNomeRazaoSocial: string;
    Placa: string;
    Chassi: string;
    NotaFiscalNumero: string;
    DataHoraEmissao: string;
    NfsePayload: string;
    NfsePdfUrl: string;
    NfsePdfStorageId: string;
    NfsePdfArquivoNome: string;
}